import { render, staticRenderFns } from "./PermissionsInputField.vue?vue&type=template&id=e1e85b8c&scoped=true"
import script from "./PermissionsInputField.vue?vue&type=script&lang=js"
export * from "./PermissionsInputField.vue?vue&type=script&lang=js"
import style0 from "./PermissionsInputField.vue?vue&type=style&index=0&id=e1e85b8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e85b8c",
  null
  
)

export default component.exports